// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from "react";

function TradingViewWidget() {
    const container = useRef(null);

    useEffect(() => {
        if (!container.current) return;

        // Clear previous chart before appending a new one
        container.current.innerHTML = "";

        const script = document.createElement("script");
        script.src =
            "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = `
      {
        "symbol": "NASDAQ:AAPL",
        "interval": "D",
        "timezone": "Etc/UTC",
        "theme": "dark",
        "style": "1",
        "locale": "en",
        "hide_top_toolbar": false,
        "hide_side_toolbar": true,
        "allow_symbol_change": true,
        "backgroundColor": "#0F0F0F",
        "gridColor": "rgba(242, 242, 242, 0.06)",
        "autosize": true
      }`;

        container.current.appendChild(script);

        return () => {
            // Cleanup when component unmounts
            // container.current.innerHTML = "";
        };
    }, []);

    return (
        <div
            className="tradingview-widget-container"
            ref={container}
            style={{ height: "100%", width: "100%" }}
        >
            <div className="tradingview-widget-container__widget" />
        </div>
    );
}

export default memo(TradingViewWidget);
